/**
 * An error that bubbles up from Promise-returning promises, if an operation could not be completed
 * because something else has already cancelled it.
 *
 * For example, if "loadComponentInSourcelessIframe" is called but then the iframe is immediately disposed,
 * the "loadedInfo.container" Promise cannot return a Container object. Instead, it will throw
 * a CancellationError to let the the caller know that the operation has been aborted.
 *
 * Hosts can do a `error instanceof CancellationError` check to ignore the error (thus preventing
 * it from triggering a normal error flow, or being captured in telemetry, etc.)
 */
export class CancellationError extends Error {
  constructor(reason: string) {
    super('Cancellation Error: ' + reason);

    // For an object extending a native type like Error, need to set the prototype explicitly
    Object.setPrototypeOf(this, CancellationError.prototype);
  }
}
